import createIcon from '../../createIcon';

/**
 * @component @name LightbulbCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMiAxOUMxMS4xNyAxOSAxMC41IDE4LjMzIDEwLjUgMTcuNUgxMy41QzEzLjUgMTguMzMgMTIuODMgMTkgMTIgMTlaTTE1IDE2LjVIOVYxNUgxNVYxNi41Wk0xNC45NyAxNEg5LjAzQzcuOCAxMy4wOSA3IDExLjY0IDcgMTBDNyA3LjI0IDkuMjQgNSAxMiA1QzE0Ljc2IDUgMTcgNy4yNCAxNyAxMEMxNyAxMS42NCAxNi4yIDEzLjA5IDE0Ljk3IDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LightbulbCircle = createIcon('LightbulbCircle', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 19C11.17 19 10.5 18.33 10.5 17.5H13.5C13.5 18.33 12.83 19 12 19ZM15 16.5H9V15H15V16.5ZM14.97 14H9.03C7.8 13.09 7 11.64 7 10C7 7.24 9.24 5 12 5C14.76 5 17 7.24 17 10C17 11.64 16.2 13.09 14.97 14Z',
      key: '13htfo',
    },
  ],
]);

export default LightbulbCircle;
